goog.provide("shadow.js.shim.module$$mui$material$Table$default");
shadow.js.shim.module$$mui$material$Table$default = shadow.js.shim.module$$mui$material$Table.default;
